import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { ExamGradeApi, ExamGradeDto } from "../../api-clients/api";
import { getApiUrl } from "../../api-clients";
import Loading from "../Shared/Loading";
import NoResult from "../Shared/NoResult";
import { dateToString } from "../../helper";
import { useTranslation } from "react-i18next";

interface IProps {
  studentPathId: string;
}
export default function StudentGrades({ studentPathId }: IProps) {
  const { t } = useTranslation();
  const [examGradeApi] = useState<ExamGradeApi>(new ExamGradeApi(getApiUrl()));
  const [grades, setGrades] = useState<ExamGradeDto[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    examGradeApi
      .studentPath(studentPathId)
      .then((res) => {
        setGrades(res);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [examGradeApi, studentPathId]);

  return (
    <Card>
      <CardHeader title={t("examGrades.title")} />
      <CardContent>
        {!isLoading ? (
          grades.length > 0 ? (
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("examGrades.subject")}</TableCell>
                    <TableCell align="right">{t("examGrades.grade")}</TableCell>
                    <TableCell>{t("common.date")}</TableCell>
                    <TableCell>{t("teachers.singular")}</TableCell>
                    <TableCell>{t("common.comment")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {grades.map((g) => (
                    <TableRow key={g.examGradeId}>
                      <TableCell>{g.subjectName}</TableCell>
                      <TableCell align="right">
                        {g.gradeText && g.gradeText.length > 0
                          ? g.gradeText
                          : g.gradeValue}
                      </TableCell>
                      <TableCell>{dateToString(g.date)}</TableCell>
                      <TableCell>{g.teacherName}</TableCell>
                      <TableCell>{g.comment}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <NoResult />
          )
        ) : (
          <Loading />
        )}
      </CardContent>
    </Card>
  );
}
